namespace $ {

	$mol_style_define( $shm_projects_task_chat, {
		Chat_page: {
			flex: { basis: '30rem', grow: 0, shrink: 0 },
			width: '30rem',
			minWidth: '30rem',
		},
	} )

}
